import { format, parseISO } from 'date-fns';
import { Article } from '@repo/types';
import { ARTICLE_PUBLISHED_DATE_DETAILED_FORMAT } from '../../constants';
import { TagList } from '../TagList';
import { PropsWithChildren } from 'react';
import { Image, ImageVariant } from '../../../common/components/Image';

export type ArticlePreviewProps = PropsWithChildren<{
  article: Article;
}>;

export function ArticlePreview({ article, children }: ArticlePreviewProps) {
  const publishedDate = article.publishDate
    ? format(parseISO(article.publishDate), ARTICLE_PUBLISHED_DATE_DETAILED_FORMAT)
    : '';

  return (
    <div className="article-details">
      <span className="article-details__page-label">news</span>
      <h1 className="article-details__title">{article.title}</h1>
      <div className="article-details__image-wrapper">
        <Image
          className="article-details__image"
          variant={ImageVariant.Detail}
          src={article.imageSrc}
          alt={article.title}
        />
      </div>
      <div className="article-details__main-wrapper">
        <aside className="article-details__meta">
          <div>
            <p className="article-details__date">{publishedDate}</p>
            <p className="article-details__author">by {article.author}</p>
            {article.imageAuthor && <p className="article-details__date">Photo by {article.imageAuthor}</p>}
          </div>
          <TagList tags={article.tags} />
        </aside>
        <div className="article-details__content-wrapper">
          <h3>{article.summary}</h3>
          <div className="article-details__content" dangerouslySetInnerHTML={{ __html: article.content }} />
          <div className="article-details__social-networks">
            <h4>Follow us on Social for more:</h4> <>{children}</>
          </div>
        </div>
      </div>
    </div>
  );
}
